import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { PAGE_PERMISSIONS, CRUD_PERMISSIONS } from "../constants/user";
import Icon from "./common/Icon";
import litigation from "../images/litigation.svg";
import GSTR9CIcon from "../images/GSTR9C.svg";
import Gstr3bIcon from "../images/GSTR3B.svg";
import GSTR9Icon from "../images/GSTR9.svg";
import Corporate from "../images/Corporate.svg";
import VATReturns from "../images/VATReturns.svg";
import Reports from "../images/Reports.svg";

import RefundIcon from "../images/RefundIcon.png";
import gstr1Icon from "../images/GSTR1.svg";
import LitigationIcon from "../images/Litigation.png";
import StatementIcon from "../images/StatementIcon.png";
import ClientInfo from "../images/ClientInfo.png";
import reconciliationIcon from "../images/reconciliationIcon.png";

import Base from "./Base";
import useCheckAuthorization from "../hooks/checkAuthorization";
import ChatPopup from "./common/ChatPopup";
import CreateNewClient from "./clients/CreateNewClient";
import { getPeriods, resetStore } from "../slices/periodReducer";

import {
  updateClient,
  resetStore as clientResetStore,
  getSingleClient,
} from "../slices/clientReducer";
import {
  CREATE_CLIENT_SCHEMA,
  CREATE_CLIENT_FIELDS,
} from "../constants/clients";
import { useEffect, useState } from "react";
import { Alert, Col, Row, Breadcrumb } from "react-bootstrap";
import {
  getLitigation,
  resetLitigationState,
} from "../slices/litigationReducer";
import { truncateText } from "../utils";

function TaxForms() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, loading, total_count, client: singleClient } =
    useSelector((state) => state.clients);
  const [current_page, setCurrentPage] = useState(1);
  //const { permissions } = useSelector((state) => state.common);
  const { client_id } = useParams();
  const [errors, setErrors] = useState({});
  //const [show, openModal] = useState(false)
  const [showClient, openClientModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  //const [updateData, setValues] = useState({});
  const { error, client, success, successMsg } = useSelector(
    (state) => state.periods
  );

  const {
    error: clientError,
    success: clientSuccess,
    successMsg: clientSuccessMsg,
  } = useSelector((state) => state.clients);
  const editClientPermission = useCheckAuthorization(
    CRUD_PERMISSIONS.client.edit
  );
  const hasPermission = useCheckAuthorization(PAGE_PERMISSIONS.client);
  console.log("client_id", client_id);

  const gstr1Click = () => {
    navigate(`/gstr-1/${client_id}`);
  };

  const refundsClick = () => {
    navigate(`/refunds/${client_id}`);
  };

  const statement3Click = () => {
    navigate(`/periods/${client_id}`);
  };

  const reconciliationClick = () => {
    navigate(`/RoDTEP/RoSCTL/${client_id}`);
  };

  const gstr3bClick = () => {
    navigate(`/gstr3b/${client_id}`);
  };

  const gstr9Click = () => {
    navigate(`/gstr9/${client_id}`);
  };

  const gstr9cClick = () => {
    navigate(`/gstr9c/${client_id}`);
  };

  const litigationClick = () => {
    navigate(`/litigation/${client_id}`);
  };

  const gstRepoClick = () => {
    navigate(`/gstrepo/${client_id}`);
  };

  // const hsnClick = () => {
  //   navigate(`/hsn/sac/${client_id}`);
  // };

  useEffect(() => {
    dispatch(getSingleClient(client_id));
    if (!hasPermission) {
      navigate("/authorization-error");
    }
    return () => {
      dispatch(resetStore("all"));
      dispatch(clientResetStore());
    };
  }, []);

  useEffect(() => {
    dispatch(getPeriods({ id: client_id, page_number: current_page }));
  }, [client_id]);

  useEffect(() => {
    if (showClient && client_id)
      dispatch(getPeriods({ id: client_id, page_number: current_page }));
  }, [client_id, showClient]);

  /*useEffect(()=>{
    if (period.id) {
        setIsUpdate(true) 
        setValues(period)
        openModal(true)
    }
  },[period]);*/

  const isCheckboxList = (element) => {
    return (
      element instanceof NodeList &&
      element.length > 0 &&
      element[0] instanceof HTMLInputElement &&
      element[0].type === "checkbox"
    );
  };

  const onClientSubmit = async (e, isUpdate) => {
    e.preventDefault();
    const values = {};
    Object.keys(CREATE_CLIENT_FIELDS).forEach((field) => {
      if (e.target[field].type === "checkbox") {
        // For checkboxes, use the `checked` property
        values[field] = e.target[field].checked;
      } else if (isCheckboxList(e.target[field])) {
        values[field] = Array.from(e.target[field])
          .filter((checkbox) => checkbox.checked)
          .map((checkbox) => checkbox.value);
      } else {
        values[field] = e.target[field].value;
      }
    });
    try {
      const data = await CREATE_CLIENT_SCHEMA.validate(values, {
        abortEarly: false,
      });
      if (data) {
        dispatch(updateClient({ data, page_number: 1, client_id: client.id }));
      }
      openClientModal(false);
      setErrors({});
      setIsUpdate(false);
    } catch (err) {
      const errData = [];
      err.inner.forEach((e) => {
        errData[e.path] = e.message;
        setErrors(errData);
      });
    }
  };

  const handleClientModalClose = () => {
    openClientModal(false);
    setIsUpdate(false);
    dispatch(resetStore());
  };

  return (
    <Base hideDatepicker={true}>
      <Row>
        <Col className="mr-auto text-center">
          <Breadcrumb>
            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/" }}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/clients" }}>
              Clients
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Tax-Forms</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <div className="flex flex-wrap gap-x-10 items-center">
        {useCheckAuthorization(PAGE_PERMISSIONS.client) && (
          <>
            <Icon
              title={truncateText(singleClient && singleClient.client_name, 20)}
              imageUrl={ClientInfo}
              onClickFunc={() => navigate(`/client-process/${singleClient.id}`)}
              className="v-icons"
            />
            {/* <Icon
              className="v-icons"
              title="GST Repository"
              imageUrl={LitigationIcon}
              onClickFunc={gstRepoClick}
            /> */}

            {/* <Icon
            className="v-icons"
            title="HSN/SAC"
            imageUrl={litigation}
            onClickFunc={hsnClick}
          /> */}
          </>
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.gstr3b) && (
          <Icon
              className="v-icons"
              title="VAT Returns"
              imageUrl={VATReturns}
              onClickFunc={gstr3bClick}
            />
        )}
        {/* {useCheckAuthorization(PAGE_PERMISSIONS.gstr9) && (
            <Icon
              className="v-icons"
              title="Corporate Tax Return"
              imageUrl={Corporate}
              onClickFunc={gstr9Click}
            />
        )} */}
        {useCheckAuthorization(PAGE_PERMISSIONS.gstr9c) && (
            <Icon
              className="v-icons"
              title="Reports"
              imageUrl={Reports}
              onClickFunc={gstr9cClick}
            />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.gstr1) && (
            <Icon
              className="v-icons"
              title="Corporate Tax Return"
              imageUrl={Corporate}
              onClickFunc={gstr1Click}
            />
        )}
        {/* {useCheckAuthorization(PAGE_PERMISSIONS.refund) && (
            <Icon
              className="v-icons"
              title="Refunds"
              imageUrl={RefundIcon}
              onClickFunc={refundsClick}
            />
        )} */}
        {useCheckAuthorization(PAGE_PERMISSIONS.litigation) && (
            <Icon
              className="v-icons"
              title="Litigation"
              imageUrl={LitigationIcon}
              onClickFunc={litigationClick}
            />
        )}
        {/* {useCheckAuthorization(PAGE_PERMISSIONS.period) && (
          <Icon
            className="v-icons"
            title="SB Data"
            imageUrl={StatementIcon}
            onClickFunc={statement3Click}
          />
        )}
        {useCheckAuthorization(PAGE_PERMISSIONS.reconciliation) && (
          <Icon
            className="v-icons"
            title="RoDTEP / RoSCTL"
            imageUrl={reconciliationIcon}
            onClickFunc={reconciliationClick}
          />
        )} */}
      </div>
      <ChatPopup client_id={client_id} chat_type="GENERAL" />
      <CreateNewClient
        fields={CREATE_CLIENT_FIELDS}
        handleSubmit={onClientSubmit}
        errors={errors}
        show={showClient}
        onHideFunc={handleClientModalClose}
        isUpdate={isUpdate}
        values={client || {}}
        editClientPermission={editClientPermission}
      />
    </Base>
  );
}

export default TaxForms;
